/**
 * Validacao de digito verificador do CNPJ Alfanumerico (NT 009 - Receita Federal).
 * Posicoes 1-12 aceitam letras (A-Z) e numeros; posicoes 13-14 (DV) continuam numericas.
 * O calculo do DV usa o valor de cada caractere (codigo ASCII - 48), o que preserva
 * o algoritmo classico (peso 2..9) para CNPJs totalmente numericos.
 */
const PESOS_DV1 = [5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];
const PESOS_DV2 = [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];

function valorCaractere (caractere) {
  return caractere.charCodeAt(0) - 48;
}

function calcularDigitoVerificador (base, pesos) {
  let soma = 0;
  for (let i = 0; i < base.length; i++) {
    soma += valorCaractere(base[i]) * pesos[i];
  }
  const resto = soma % 11;
  return resto < 2 ? 0 : 11 - resto;
}

const cnpjAlfanumerico = {
  isValid: function (cnpj) {
    if (!cnpj) return false;
    const valor = cnpj.toString().toUpperCase();
    if (!/^[A-Z0-9]{14}$/.test(valor)) return false;
    if (!/^[0-9]{2}$/.test(valor.substring(12, 14))) return false;

    const base = valor.substring(0, 12);
    const dv1 = calcularDigitoVerificador(base, PESOS_DV1);
    const dv2 = calcularDigitoVerificador(base + dv1, PESOS_DV2);

    return valor === base + dv1.toString() + dv2.toString();
  }
};

export default cnpjAlfanumerico;
